// Room reservation colors are shared between the timetable calendar and the infoscreen
// room calendar slides so the same booking reads the same way on both surfaces.
export const roomEventColor = '#2563EB';
// Same lightness band as roomEventColor so 'your reservation' reads as a hue change, not a
// brightness jump, and still carries white text (5.0:1).
export const roomOwnEventColor = '#15803D';

// Deterministic per-room colors for the multi-room infoscreen week view, where several rooms'
// reservations overlay in the same day columns and need to stay visually distinguishable. Indexed
// by a room's position in the selected room list, so a given room keeps its color across renders.
// Avoids roomOwnEventColor's green, which has a different meaning (the viewer's own event) elsewhere.
//
// Every color carries white event text at 4.5:1 or better and sits in a narrow lightness band, so no
// room's bookings glare next to another's when whole-day blocks fill a column on a dark TV screen.
export const roomWeekPalette = [
    '#2563EB',
    '#C2410C',
    '#7C3AED',
    '#0E7490',
    '#DB2777',
    '#A16207',
    '#BE123C',
    '#4D7C0F',
];

export function getRoomWeekColor(roomIndex: number): string {
    return roomWeekPalette[roomIndex % roomWeekPalette.length] ?? roomEventColor;
}
